import React, { useEffect, useState } from "react"
import {
    AlertType, LanctoContaPag, ParamsEstLanctoCartao, classBorderLabelDark, classBt, classInput, classInputDark,
    classLabel, classLabelDark, classbtAzul, classbtColunasVermelho,
} from "../../Utils/Types"
import { Funcoes } from "../../Utils/Funcoes"
import { FeedbackMessage } from "../FeedbackMessage/feedback-message"
import { LanctoCartaoService } from "../../Pages/LancamentoCartao/LanctoCartaoService"
import { MdOutlineCreditCardOff } from "react-icons/md"

export type Props = {
    visible: boolean,
    totSelecionado: number,
    qtdLanctoCartaoSelecionado: number,
    handleModalClose: () => void,
    handleConfirm: () => Promise<boolean>,
    lanctoCartaoSelectedList: number[],
    bordero: number[],
}

interface Pagamento {
    id_conta: number;
    valor: number;
    description: string;
}

export const ModalEstLancamentoCartao = React.memo(({ visible, handleModalClose, handleConfirm, lanctoCartaoSelectedList, totSelecionado, qtdLanctoCartaoSelecionado, bordero }: Props) => {

    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [loading, setLoading] = useState<boolean>(false)
    const [visibleMsg, setVisibleMsg] = useState<boolean>(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // -----------------------------------------------
    // ---------- ATRIBUTOS  -------------------------
    // -----------------------------------------------
    const [senhaUsuario, setSenhaUsuario] = useState("")
    const [motivo, setMotivo] = useState("")

    // -----------------------------------------------
    // ---------- ATRIBUTOS LANCAMENTO CONTAS --------
    // -----------------------------------------------
    const [lanctoContasList, setLanctoContasList] = useState<LanctoContaPag[]>([])

    //--------------------------------------------------------------------------------------------- USEEFFECT ------------------------------------------------------------------------------------------//
    const getContaPagamento = async () => {
        setLoading(true)
        try {

            const resp = await LanctoCartaoService.BuscarPagamentos(bordero);

            const agrupado: { [key: string]: Pagamento } = {};

            // Agrupar por id_fpagto e somar valores
            for (let i = 0; i < resp.data.length; i++) {
                const item = resp.data[i];
                const id = item.id_conta;

                if (!agrupado[id]) {
                    agrupado[id] = { ...item }; // copia o item inteiro
                } else {
                    agrupado[id].valor += item.valor; // soma os valores
                }
            }

            // Transformar o objeto agrupado em array
            const listaProcessada = Object.values(agrupado);

            setLanctoContasList(listaProcessada);

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível obter as formas de pagamento`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {

        if (visible) {

            getContaPagamento()

            let modal = document.getElementById('modal_est_lanc_cartao')
            let modalContent = document.getElementById('modal_content_est_lanc_cartao')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-1000px]')
                    modalContent.classList.add('mt-24')
                }
            }

        } else {

            let modal = document.getElementById('modal_est_lanc_cartao')
            let modalContent = document.getElementById('modal_content_est_lanc_cartao')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-1000px]')
                    modalContent.classList.remove('mt-24')
                }
            }
        }

    }, [visible])

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    //--------------------------------------------------------------------------------------------- INPUTS ------------------------------------------------------------------------------------------//
    const handleChangeSenhaUsuario = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSenhaUsuario(e.target.value)
    }

    const handleChangeMotivo = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMotivo(e.target.value)
    }

    //---------------------------------------------------------------------------------------------  ESTORNAR LANÇAMENTOS ------------------------------------------------------------------------------------------//
    const handleEstornarDuplicata = async () => {

        setVisibleMsg(false)
        setLoading(true)

        try {

            let totConta = 0
            lanctoContasList.map(item => totConta += item.valor)

            const parametros: ParamsEstLanctoCartao = {
                senha_usuario: '',
                lanctoCartao: [],
                lanctoContasList: lanctoContasList,
                bordero: [],
                motivo: ''
            }

            parametros.senha_usuario = senhaUsuario
            parametros.bordero = bordero
            parametros.motivo = motivo

            const retAPI = await LanctoCartaoService.Estornar(parametros)

            if (retAPI.error) {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage(retAPI.msg || '')
                    clearTimeout(timer)
                }, 250)

            } else {

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage(`Lançamento(s) estornado(s) com sucesso`)

                const dados = await handleConfirm()

                if (dados) {
                    const aguarde = setTimeout(() => {
                        clearFields()
                        handleModalClose()
                        clearTimeout(aguarde)
                    }, 250)
                }
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível estornar o(s) lançamento(s). Por favor, tente novamente`)

        } finally {
            setLoading(false)
        }

    }

    const clearFields = () => {

        setSenhaUsuario('')
        setMotivo("")
        setLanctoContasList([])
    }

    const fecharModal = () => {

        setVisibleMsg(false)
        handleModalClose()

        setSenhaUsuario('')
        setMotivo("")
        setLanctoContasList([])
    }

    return (

        <div id="modal_est_lanc_cartao" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40 bg-white`}>

            <div id="modal_content_est_lanc_cartao" className={`relative flex flex-col w-[95%] md:w-[80%] xl:w-[60%] h-[510px] bg-white dark:bg-slate-600 rounded-lg mt-[-1000px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <MdOutlineCreditCardOff size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-200`}  />
                    </div>
                    <span className={`mx-2 text-base font-semibold leading-6 text-slate-700 dark:text-slate-200`}>Estorno de Lançamento</span>
                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full`}>

                    <div className={`grid grid-cols-12 gap-3 bg-white dark:bg-slate-600 py-3 h-full overflow-y-auto px-2`}>

                        <div className={`col-span-12 md:col-span-5 `}>

                            <div className={`grid grid-cols-12 gap-3`}>

                                <div className={`relative col-span-12 mt-2`}>
                                    <input id="qtd_estornar_lanctoCartao" className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} type='text' disabled={true} placeholder=' ' value={qtdLanctoCartaoSelecionado} readOnly />
                                    <label htmlFor="qtd_estornar_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Qtde de Lançamentos</label>
                                </div>

                                <div className={`relative col-span-12 mt-2`}>
                                    <input id="vl_estornar_lanctoCartao" className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} type="text" disabled={true} placeholder=' ' value={Funcoes.numberFormat(totSelecionado, 'decimal', 2, 2)} readOnly />
                                    <label htmlFor="vl_estornar_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do Estorno</label>
                                </div>

                                <div className={`relative col-span-12 mt-2`}>
                                    <input id="senha_usuario_estornar_lanctoCartao" className={`${classInput} ${classInputDark}`} type='password' inputMode="text" placeholder=' ' autoComplete="off" value={senhaUsuario} onChange={handleChangeSenhaUsuario} />
                                    <label htmlFor="senha_usuario_estornar_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>* Senha do Usuário</label>
                                </div>

                                <div className={`relative col-span-12 mt-2`}>
                                    <textarea id="motivo_estornar_lanctoCartao" className={`${classInput} ${classInputDark} h-[140px] resize-none`} placeholder=' ' maxLength={92} value={motivo} onChange={handleChangeMotivo} />
                                    <label htmlFor="motivo_estornar_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>* Motivo</label>
                                </div>

                            </div>

                        </div>

                        <div className={`col-span-12 md:col-span-7 h-[500px] sm:h-[350px] border border-slate-400 dark:border-slate-700 rounded-sm px-2`}>

                            <div className={`grid grid-cols-12 gap-3`}>

                                <div className={`relative col-span-12 mt-1`}>

                                    <div className={`w-full`}>

                                        <ul className={`w-full h-full text-slate-800 dark:text-slate-200 dark:bg-slate-500`}>

                                            <li className={`h-10`}>

                                                <div className={`w-full flex flex-row h-10 font-mono`}>

                                                    <div className={`flex items-center w-[65%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Conta</span>
                                                    </div>

                                                    <div className={`flex items-center justify-end w-[35%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Valor</span>
                                                    </div>

                                                </div>

                                            </li>

                                        </ul>

                                    </div>

                                    <div className={`overflow-auto h-full max-h-[1000px] scrollbar-custom dark:scrollbar-custom-dark mb-2`}>

                                        <div className={`w-full`}>

                                            <ul className={`w-full`}>

                                                {lanctoContasList.length > 0 &&
                                                    lanctoContasList.map((item) => (

                                                        <li key={item.id_conta} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>

                                                            <div className={`w-full flex flex-row h-[40px] font-mono text-black dark:text-slate-200`}>

                                                                <div className={`flex items-center w-[65%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{item.description}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[35%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</span>
                                                                </div>

                                                            </div>

                                                        </li>
                                                    ))
                                                }

                                            </ul>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                {loading &&

                    <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 bg-slate-300 dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        disabled={loading}
                        onClick={fecharModal}
                        className={`${classbtColunasVermelho} max-w-[150px]`} >
                        CANCELAR
                    </button>

                    <button
                        disabled={loading}
                        onClick={handleEstornarDuplicata}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-white dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `ESTORNAR` : "AGUARDE"}
                    </button>

                </div>

            </div>

        </div>
    )
})